import Checkbox from './components/checkbox.vue';
import Heading from './components/heading.vue';
import HeaderAction from './components/header-action.vue';

const VueTable2Checkbox = {
    install(Vue, options) {
        Vue.component('vuetable2-checkbox', Checkbox);
        Vue.component('vuetable2-heading', Heading);
        Vue.component('vuetable2-header-action', HeaderAction);
    },
};

export default VueTable2Checkbox;
